import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";

const RequestModeBadge = ({ mode }) => {
  var isClassicMode = mode === "classic";
  var title = isClassicMode
    ? "Não disponível para aceitação imediata"
    : "Aceitação imediata";

  return (
    <Tooltip title={title}>
      <Chip
        className={
          isClassicMode
            ? "request-mode-classic-badge-avatar"
            : "request-mode-auto-badge-avatar"
        }
        label={"EI"}
      ></Chip>
    </Tooltip>
  );
};

export default RequestModeBadge;
